import React from 'react';

import { useTranslate } from '@src/core/hooks';

import {
  SummaryItemSellerAvatar,
  SummaryItemSellerInfo,
  SummaryItemSellerLabel,
  SummaryItemSellerName,
  SummaryItemSellerRow,
} from '../styles';

type SummaryItemSellerProps = {
  name: string;
  logoUrl?: string | null;
};

export const SummaryItemSeller = (props: SummaryItemSellerProps) => {
  const { name, logoUrl } = props;
  const { i18n } = useTranslate();

  return (
    <SummaryItemSellerRow>
      <SummaryItemSellerLabel>{i18n('checkout_sold_by')}</SummaryItemSellerLabel>
      <SummaryItemSellerInfo>
        {logoUrl ? <SummaryItemSellerAvatar src={logoUrl} alt={name} /> : null}
        <SummaryItemSellerName>{name}</SummaryItemSellerName>
      </SummaryItemSellerInfo>
    </SummaryItemSellerRow>
  );
};

export default SummaryItemSeller;
